import { render, staticRenderFns } from "./CaseRecommend.vue?vue&type=template&id=b5ecaae2&scoped=true"
import script from "./CaseRecommend.vue?vue&type=script&lang=js"
export * from "./CaseRecommend.vue?vue&type=script&lang=js"
import style0 from "./CaseRecommend.vue?vue&type=style&index=0&id=b5ecaae2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ecaae2",
  null
  
)

export default component.exports